<template>
    <div>
        <div class="downloadRecMask"></div>
        <g-bottom-drawer
            :visible="visible"
            :height="recDownloadGames.length === 8 ? 1339 : 1407"
            @coverClick="closeDrawer"
        >
            <div
                class="download-wrapper"
                :style="{
                    display: visible ? 'block' : 'none',
                }"
            >
                <div class="download-wrapper-head">
                    <div class="download-wrapper-title">
                        <span class="download-wrapper-title-left">「{{ appName }}」</span>
                        <span class="download-wrapper-title-right">玩家专属推荐</span>
                    </div>
                    <img
                        :src="closeDrawerIcon" alt=""
                        class="closeIcon"
                        @click="closeDownloadDrawer"
                    >
                </div>
                <div
                    v-if="recDownloadGames.length === 8"
                    class="download-wrapper-center"
                >
                    <div
                        v-for="(item, index) in recDownloadGames" :key="index"
                        class="download-wrapper-center-item" @click="changeType(item)"
                    >
                        <img
                            :src="item.icon_url"
                            class="download-wrapper-center-left"
                        >
                        <div class="download-wrapper-center-right">
                            <div class="download-item-name">{{ item.app_name }}</div>
                            <div
                                v-if="item.operate_tags"
                                class="download-item-operate-tag"
                            >
                                {{ item.operate_tags }}
                            </div>
                            <div class="download-item-tags">
                                <div
                                    v-for="(tag, index) in item.desc_tags.slice(0, 2)" :key="index"
                                >
                                    <div class="download-item-tag">
                                        {{ tag }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <img
                            :src="item.isCurrent ? downloadIcon2 : downloadIcon1" alt=""
                            class="currentIcon"
                        >
                    </div>
                </div>
                <div
                    v-if="recDownloadGames.length === 4"
                    class="download-wrapper-center-4c"
                >
                    <div
                        v-for="(item, index) in recDownloadGames" :key="index"
                        class="download-wrapper-center-item" @click="changeType(item)"
                    >
                        <img
                            :src="item.icon_url"
                            class="download-wrapper-center-left-4c"
                        >
                        <div class="download-wrapper-center-right-4c">
                            <div class="download-item-name">{{ item.app_name }}</div>
                            <div
                                v-if="item.operate_tags"
                                class="download-item-operate-tag"
                            >
                                {{ item.operate_tags }}
                            </div>
                            <div class="download-item-tags">
                                <div
                                    v-for="(tag, index) in item.desc_tags" :key="index"
                                >
                                    <div class="download-item-tag">
                                        {{ tag }}
                                    </div>
                                </div>
                            </div>
                            <div class="download-item-desc">
                                <div class="download-item-desc-name">推荐理由:</div>
                                <div class="download-item-desc-txt">{{ item.description }}</div>
                            </div>
                        </div>
                        <img
                            :src="item.isCurrent ? downloadIcon2 : downloadIcon1" alt=""
                            class="currentIcon"
                        >
                    </div>
                </div>
                <div
                    class="download-wrapper-bottom"
                    :style="{'margin-top': recDownloadGames.length === 8 ? '' : '90'}"
                >
                    <div class="download-wrapper-change-all" @click="changeAllState">
                        <img
                            :src="changeAll ? downloadIcon2 : downloadIcon1" alt=""
                            class="all-icon"
                        >
                        <div class="change-all-txt">
                            全选
                        </div>
                    </div>
                    <div
                        :class="newDownloadArr.length > 0 ? 'download-btn' : 'download-btn-only-read'"
                        :style="{'background': newDownloadArr.length > 0 ? '#1F97F4' : '#D8D8D8'}"
                        @click="download"
                    >
                        <div class="download-btn-txt">
                            安全下载
                        </div>
                    </div>
                </div>
            </div>
        </g-bottom-drawer>
    </div>

</template>

<script>
import GBottomDrawer from '@/composition-components/GBottomDrawer.vue';
import CloseDrawerIcon from 'public/assets/imgs/xiuxiu_panel_close.png';
import downloadIcon1 from 'public/assets/imgs/download-icon1.png';
import downloadIcon2 from 'public/assets/imgs/download-icon2.png';
import {getQueryString} from '@/utils/url';
import {downloadApk} from '@/utils/browser';
export default {
    components: {
        GBottomDrawer,
    },
    props: {
        showDownload: {
            type: Boolean,
            default: false,
        },
        recDownloadGame: {
            type: Array,
            default: () => [],
        },
        appName: {
            type: String,
            default: '',
        },
        resumeDownload: {
            type: Boolean,
            default: false,
        },
        appType: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            visible: false,
            closeDrawerIcon: CloseDrawerIcon,
            isAllCurrent: false,
            changeAll: false,
            downloadIcon1: downloadIcon1,
            downloadIcon2: downloadIcon2,
            isWifi: this.$wifi,
            downloadArr: [],
            recDownloadGames: [],
            lastdownloadArr: [],
        };
    },
    created() {
        this.visible = this.showDownload;
        this.recDownloadGames = this.recDownloadGame;
        this.recDownloadGames.forEach(item => {
            this.$set(item, 'isCurrent', false);
        });
        this.doShowLog();
    },
    computed: {
        newDownloadArr() {
            return this.downloadArr.filter((item, index) => {
                if (item.isCurrent === true) {
                    return this.downloadArr.indexOf(item) === index;
                }
            });
        },
    },
    watch: {
        visible: {
            handler() {
                this.recDownloadGames[0].isCurrent = true;
                this.downloadArr.push(this.recDownloadGames[0]);
            },
        },
        resumeDownload: {
            handler() {
                this.download();
            },
        },
    },
    methods: {
        closeDrawer() {
            this.visible = false;
            this.$emit('closeDownloadDrawer', false);
        },
        closeDownloadDrawer() {
            this.visible = false;
            this.$emit('closeDownloadDrawer', false);
        },
        changeType(item) {
            item.isCurrent = !item.isCurrent;
            if (item.isCurrent === true) {
                this.downloadArr.push(item);
            }
            this.doClickLog('clickType', 'isCheck');
        },
        changeAllState() {
            this.changeAll = !this.changeAll;
            if (this.changeAll) {
                this.recDownloadGames.forEach(item => {
                    item.isCurrent = true;
                    this.downloadArr.push(item);
                });
            }
            else {
                this.recDownloadGames.forEach(item => {
                    item.isCurrent = false;
                });
                this.downloadArr = [];
            }
            this.doClickLog('clickType', 'checkAll');
        },
        download() {
            this.downloadArr = this.downloadArr.filter((item, index) => {
                return this.downloadArr.indexOf(item) === index;
            });
            if (this.isWifi && this.downloadArr.length > 0 && !this.resumeDownload) {
                this.$emit('showWifiToast', true);
            }
            else if (this.isWifi && this.downloadArr.length > 0 && this.resumeDownload) {
                if (this.resumeDownload) {
                    this.downloadArr.forEach((item, index) => {
                        if (item.isCurrent) {
                            setTimeout(() => {
                                downloadApk(item.url, item.package_name);
                            }, 1500 * index);
                            this.visible = false;
                            this.$emit('closeDownloadDrawer', false);
                            this.lastdownloadArr.push(item);
                            this.$toast(`${this.lastdownloadArr.length}款游戏下载中，请去下载管理查看进度哦`);
                        }
                    });
                }
            }
            else if (this.downloadArr.length > 0) {
                this.downloadArr.map((item, index) => {
                    if (item.isCurrent === true) {
                        setTimeout(() => {
                            downloadApk(item.url, item.package_name);
                        }, 1500 * index);
                        this.visible = false;
                        this.$emit('closeDownloadDrawer', false);
                        this.lastdownloadArr.push(item);
                        this.$toast(`${this.lastdownloadArr.length}款游戏下载中，请去下载管理查看进度哦`);
                    }
                });
            }
            else {
                this.$emit('closeDownloadDrawer', false);
            }
            this.doClickLog('downloadBtnClick');
        },
        doShowLog() {
            this.$logger.display({
                value: 'showDownloadRec',
                ext: {
                    item: [
                        {
                            ext: {
                                appName: this.appName,
                                sid: getQueryString('sid') || '',
                                fromPage: getQueryString('isNewStyle') ? 'detail' : 'zone',
                                srcId: getQueryString('srcId') || '',
                                channelid: getQueryString('channelid') || '',
                                appType: this.appType,
                                moduleName: 'downloadRecommend',
                            },
                        },
                    ],
                },
            });
        },
        doClickLog(type, clickType) {
            let content = {
                value: type,
                ext: {
                    id: '',
                    ext: {
                        appName: this.appName,
                        sid: getQueryString('sid') || '',
                        fromPage: getQueryString('isNewStyle') ? 'detail' : 'zone',
                        srcId: getQueryString('srcId') || '',
                        channelid: getQueryString('channelid') || '',
                        appType: this.appType,
                        moduleName: 'downloadRecommend',
                        clickPos: clickType,
                        downNum: type === 'downloadBtnClick' ? this.newDownloadArr.length : '',
                    },
                },
            };
            this.$logger.click(content);
        },
    },
};
</script>

<style lang="scss">
.download-wrapper {
    z-index: 990;
    background: #fff;
    border-top-left-radius: 36px;
    border-top-right-radius: 36px;
    .download-wrapper-head {
        display: flex;
        margin: 60px 0 90px 171px;
        position: relative;
        .download-wrapper-title {
            text-align: center;
            .download-wrapper-title-left {
                max-width: 336px;
                height: 57px;
                font-family: PingFangSC-Semibold;
                font-size: 57px;
                color: #1F1F1F;
                letter-spacing: 0;
                text-align: right;
                line-height: 57px;
                font-weight: 600;
                max-width: 336px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }
            .download-wrapper-title-right {
                width: 342px;
                height: 57px;
                font-family: PingFangSC-Regular;
                font-size: 57px;
                color: #1F1F1F;
                letter-spacing: 0;
                text-align: right;
                line-height: 57px;
                font-weight: 400;
            }
        }
        .closeIcon {
            width: 36px;
            height: 36px;
            position: absolute;
            top: 0;
            right: 60px;
        }
    }
    .download-wrapper-center {
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        margin: 0 0 21px 69px;
        .download-wrapper-center-item {
            display: flex;
            position: relative;
            max-width: 528px;
            margin-right: 42px;
            margin-bottom: 60px;
            .download-wrapper-center-left {
                width: 156px;
                height: 156px;
                margin-right: 36px;
            }
            .download-wrapper-center-right {
                width: 336px;
                padding: 30px 0;
                box-sizing: border-box;
                .download-item-name {
                    height: 48px;
                    font-family: PingFangSC-Regular;
                    font-size: 48px;
                    color: #1F1F1F;
                    letter-spacing: 0;
                    line-height: 48px;
                    font-weight: 400;
                    margin-bottom: 27px;
                    max-width: 336px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                .download-item-tags {
                    display: flex;
                    align-items: center;
                    max-width: 336px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    .download-item-tag {
                        height: 39px;
                        font-family: PingFangSC-Regular;
                        font-size: 39px;
                        color: #858585;
                        letter-spacing: 0;
                        line-height: 39px;
                        font-weight: 400;
                        margin-right: 10px;
                    }
                }
                .download-item-operate-tag {
                    height: 39px;
                    font-family: PingFangSC-Regular;
                    font-size: 39px;
                    color: #FF834F;
                    letter-spacing: 0;
                    line-height: 39px;
                    font-weight: 400;
                }
            }
            .currentIcon {
                width: 60px;
                height: 60px;
                position: absolute;
                top: -10px;
                left: 105px;
            }
        }
    }
    .download-wrapper-center-4c {
        margin: 0 0 21px 69px;
        .download-wrapper-center-item {
            display: flex;
            position: relative;
            max-width: 528px;
            margin-right: 42px;
            margin-bottom: 60px;
            .download-wrapper-center-left-4c {
                width: 188px;
                height: 188px;
                margin-right: 36px;
            }
            .download-wrapper-center-right-4c {
                box-sizing: border-box;
                width: 336px;
                .download-item-name {
                    height: 48px;
                    font-family: PingFangSC-Regular;
                    font-size: 48px;
                    color: #1F1F1F;
                    letter-spacing: 0;
                    line-height: 48px;
                    font-weight: 400;
                    margin-bottom: 27px;
                    max-width: 336px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                .download-item-tags {
                    display: flex;
                    align-items: center;
                    // width: 336px;
                    margin-bottom: 27px;
                    white-space: nowrap;
                    .download-item-tag {
                        height: 39px;
                        font-family: PingFangSC-Regular;
                        font-size: 39px;
                        color: #858585;
                        letter-spacing: 0;
                        line-height: 39px;
                        font-weight: 400;
                        margin-right: 10px;
                    }
                }
                .download-item-desc {
                    display: flex;
                    align-items: center;
                    width: 900px;
                    .download-item-desc-name {
                        width: 196px;
                        height: 39px;
                        font-family: PingFangSC-Semibold;
                        font-size: 39px;
                        color: #858585;
                        letter-spacing: 0;
                        line-height: 39px;
                        font-weight: 600;
                    }
                    .download-item-desc-txt {
                        max-width: 720px;
                        font-family: PingFangSC-Regular;
                        font-size: 39px;
                        color: #858585;
                        letter-spacing: 0;
                        line-height: 39px;
                        font-weight: 400;
                        white-space: nowrap;
                        text-overflow:ellipsis;
                        overflow: hidden;
                    }
                }
                .download-item-operate-tag {
                    height: 39px;
                    font-family: PingFangSC-Regular;
                    font-size: 39px;
                    color: #FF834F;
                    letter-spacing: 0;
                    line-height: 39px;
                    font-weight: 400;
                }
            }
            .currentIcon {
                width: 60px;
                height: 60px;
                position: absolute;
                top: -10px;
                left: 137px;
            }
        }
    }
    .download-wrapper-bottom {
        display: flex;
        align-items: center;
        margin-left: 51px;
        .download-wrapper-change-all {
            display: flex;
            align-items: center;
            margin-right: 54px;
            .all-icon {
                width: 60px;
                height: 60px;
                margin-right: 21px;
            }
            .change-all-txt {
                width: 96px;
                height: 67px;
                font-family: PingFangSC-Medium;
                font-size: 48px;
                color: #222222;
                letter-spacing: 0;
                font-weight: 500;
            }
        }
        .download-btn {
            width: 909px;
            height: 132px;
            border-radius: 72px;
            .download-btn-txt {
                height: 54px;
                font-family: PingFangSC-Medium;
                font-size: 54px;
                color: #FFFFFF;
                letter-spacing: 0;
                line-height: 132px;
                font-weight: 500;
                text-align: center;
            }
        }
        .download-btn-only-read {
            width: 909px;
            height: 132px;
            border-radius: 72px;
            pointer-events: none;
            .download-btn-txt {
                height: 54px;
                font-family: PingFangSC-Medium;
                font-size: 54px;
                color: #FFFFFF;
                letter-spacing: 0;
                line-height: 132px;
                font-weight: 500;
                text-align: center;
            }
        }
    }
}
.downloadRecMask {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 980;
}
</style>